// extracted by mini-css-extract-plugin
export var body = "_i3-0";
export var sectionHeader = "_i3-4";
export var shortcutColumns = "_i3-2";
export var shortcutList = "_i3-1";
export var shortcutSection = "_i3-3";